export const calendarConstants = {
	getExceptDays: {
		REQUEST : "GET_EXCEPT_DAYS_REQUEST",
		SUCCESS : "GET_EXCEPT_DAYS_SUCCESS",
		FAILURE : "GET_EXCEPT_DAYS_FAILURE",
		CLEAR	: "CLEAR_EXCEPT_DAYS"
	}
	
}
